/**
 * contractRoutingList Group _ Osman
 * @param fb : FormBuilder
 */
export function contractRoutingListGroup (fb: any):any {
    return fb.group({
        code: fb.control('')
    });
}
